import { useState, useEffect } from 'react';
import { META, ROUTES } from './data';

export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => { const h = () => setScrolled(window.scrollY > 30); window.addEventListener('scroll', h, { passive: true }); return () => window.removeEventListener('scroll', h); }, []);
  return (
    <header className={`fixed top-0 inset-x-0 z-40 bg-[#14110F] transition-all border-b ${scrolled ? 'border-[#F59E0B]/30 py-3' : 'border-[#2A241F] py-4'}`}>
      <div className="max-w-[1500px] mx-auto px-6 lg:px-10 grid grid-cols-[auto_1fr_auto] items-center gap-6">
        <button onClick={() => setPage('home')} data-testid="aem-logo" className="text-left">
          <p className="font-mono text-[9px] tracking-[0.4em] uppercase text-[#F59E0B]">— Inst. Desk · Est. {META.est}</p>
          <p className="font-serif italic text-[24px] leading-none text-[#F8F4ED]">{META.brand}</p>
        </button>
        <nav className="hidden md:flex items-center justify-center gap-7 font-mono text-xs">
          {ROUTES.map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`aem-nav-${r.id}`} className={`px-3 py-1.5 transition-colors ${page === r.id ? 'text-[#F59E0B] border-b-2 border-[#F59E0B] -mb-[2px]' : 'text-[#F8F4ED]/65 hover:text-[#F8F4ED]'}`}>{r.label}</button>
          ))}
        </nav>
        <button onClick={() => setPage('access')} data-testid="aem-header-access" className="hidden md:inline-block bg-[#F59E0B] text-[#14110F] font-mono text-[10px] tracking-[0.32em] uppercase px-5 py-2.5 hover:bg-[#FFB94A] transition-colors">Request access →</button>
      </div>
    </header>
  );
}
